import { axiosAjax } from '@app/src/config/axios';
import { hydrateData } from './hydrators';
import { SelectItemModel } from '@app/src/common/Select/SelectModel';

export const typePropertyService = {
  async get(operationId:number): Promise<SelectItemModel[]> {
    try {
      const { data } = await axiosAjax.get(process.env.API_PROPERTY.replace(':operationId', '' + operationId));
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
